import axios from 'axios';
import { API } from '../config';

// Contesto sicuro (HTTPS o localhost): requisito OBBLIGATORIO per service worker + push.
// Su http://<ip> in chiaro le API push non esistono proprio.
export const httpsOk = () =>
  typeof window === 'undefined' || window.isSecureContext !== false;

export const supportata = () =>
  typeof navigator !== 'undefined' && 'serviceWorker' in navigator &&
  typeof window !== 'undefined' && 'PushManager' in window && 'Notification' in window;

export const standalone = () =>
  typeof window !== 'undefined' && (
    (window.matchMedia && window.matchMedia('(display-mode: standalone), (display-mode: fullscreen), (display-mode: minimal-ui)').matches) ||
    window.navigator.standalone === true   // iOS: PWA aggiunta a Home
  );

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export async function registraSW() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return null;
  try { return await navigator.serviceWorker.register('/sw.js'); }
  catch { return null; }
}

export async function statoNotifiche() {
  if (!httpsOk()) return 'non_https';
  // iOS: PushManager/Notification compaiono SOLO nella PWA installata. Controllo prima
  // l'installazione, cosi' in Safari (non installata) mostro 'installa_safari' e non 'non_supportata'.
  if (!standalone()) return 'installa_safari';
  if (!supportata()) return 'non_supportata';
  if (Notification.permission === 'denied') return 'negato';
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  return sub ? 'attive' : 'da_attivare';
}

// base = prefisso endpoint push ('/push' per il /m, '/agente/push' per la PWA agente).
// token = bearer dell'agente (l'app agente non usa l'axios default autenticato).
export async function attiva(base = '/push', token = null) {
  if (!httpsOk()) return 'non_https';
  if (!supportata()) return 'non_supportata';
  if (!standalone()) return 'installa_safari';
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') return 'negato';
  const reg = await registraSW();
  if (!reg) return 'errore';
  try {
    await navigator.serviceWorker.ready;
    const cfg = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    const { data } = await axios.get(`${API}${base}/vapid-public`, cfg);
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.key),
    });
    await axios.post(`${API}${base}/subscribe`, { subscription: sub.toJSON() }, cfg);
    return 'attive';
  } catch (e) {
    // rilancia con un messaggio leggibile per la diagnostica (il chiamante lo mostra)
    const det = e?.response?.data?.detail || e?.message || String(e);
    throw new Error(det);
  }
}

export async function disattiva(base = '/push', token = null) {
  if (!('serviceWorker' in navigator)) return 'da_attivare';
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = reg ? await reg.pushManager.getSubscription() : null;
  if (sub) {
    const cfg = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    try { await axios.post(`${API}${base}/unsubscribe`, { endpoint: sub.endpoint }, cfg); } catch (e) {}
    try { await sub.unsubscribe(); } catch (e) {}
  }
  return 'da_attivare';
}

export function clearBadge() {
  if (typeof navigator !== 'undefined' && navigator.clearAppBadge) {
    navigator.clearAppBadge().catch(() => {});
  }
}

// Imposta il badge dell'icona al numero n (0 = azzera). Utile per il conteggio non-lette.
export function setBadge(n) {
  if (typeof navigator === 'undefined') return;
  if (n > 0 && navigator.setAppBadge) navigator.setAppBadge(n).catch(() => {});
  else if (navigator.clearAppBadge) navigator.clearAppBadge().catch(() => {});
}
